<template>
<div class="c-inquiry__body">
	<div class="inquiry-form__title-block">
		<p class="inquiry-form__form-title">{{msg.personal_info}}</p>
	</div>

	<div class="row">
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="first_name" value="" class="inquiry-form__input-text" :placeholder="msg.first_name+(required_fields.first_name?' *':'')">
			</label>
		</div>
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="last_name" value="" class="inquiry-form__input-text" :placeholder="msg.last_name+(required_fields.last_name?' *':'')">
			</label>
		</div>
	</div>
	<div class="row">
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="mail" name="email" value="" class="inquiry-form__input-text" :placeholder="msg.email+(required_fields.email?' *':'')">
			</label>
		</div>
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="number" name="phone" value="" class="inquiry-form__input-text" :placeholder="msg.phone+(required_fields.phone?' *':'')">
			</label>
		</div>
	</div>

	<div class="row">
		<div class="col-12 col-lg-6">
			<p class="inquiry-form__section-lebel ">{{msg.media_type}}</p>
			<div class="c-custom-select inquiry-form__select">
					<multiselect :options="mediaData" :searchable="false" v-model="selectedMediaType" :close-on-select="true" :show-labels="true"></multiselect>
					<input type="hidden" name="media_type" :value="selectedMediaType">
			</div>
		</div>
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="media_name" value="" class="inquiry-form__input-text" :placeholder="msg.media_name+(required_fields.media_name?' *':'')">
			</label>
		</div>
	</div>
	<div class="row">
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="media_viewership" value="" class="inquiry-form__input-text" :placeholder="msg.viewership+(required_fields.viewership?' *':'')">
			</label>
		</div>
	</div>
	<div class="row">
		<div class="col-12 col-lg-6">
			<p class="inquiry-form__section-lebel ">{{msg.coverage_type}}</p>
			<div class="c-custom-select inquiry-form__select">
				<multiselect :options="coverageType" :searchable="false" v-model="selectedCoverageType" :close-on-select="true" :show-labels="true"></multiselect>
				<input type="hidden" name="coverage_type" :value="selectedCoverageType">
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-12">
			<label class="inquiry-form__label">
				<textarea name="project_description" rows="8" cols="80" :placeholder="msg.project_description+(required_fields.project_description?' *':'')" class="inquiry-form__input-textarea"></textarea>
			</label>
		</div>
	</div>
	<div class="row">
		<div class="col-12">
			<p class="inquiry-form__section-lebel ">{{msg.media_freelancer}}</p>
			<label class="inquiry-form__label">
				<textarea name="freelancer_description" rows="8" cols="80" :placeholder="msg.media_freelancer+(required_fields.media_freelancer?' *':'')" class="inquiry-form__input-textarea"></textarea>
			</label>
		</div>
	</div>
	<div class="row">
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="stay_date" value="" class="inquiry-form__input-text" :placeholder="msg.stay_date+(required_fields.stay_date?' *':'')">
			</label>
		</div>
		<div class="col-12 col-lg-6">
			<label class="inquiry-form__label">
				<input type="text" name="total_stay" value="" class="inquiry-form__input-text" :placeholder="msg.media_total_nights+(required_fields.media_total_nights?' *':'')">
			</label>
		</div>
	</div>
	<div class="row">
		<div class="col-12">
			<label class="inquiry-form__label">
				<textarea name="message" rows="8" cols="80" :placeholder="msg.message+(required_fields.message?' *':'')" class="inquiry-form__input-textarea"></textarea>
			</label>
		</div>
	</div>

	<div class="inquiry-form__bottom">
		<div class="inquiry-form__opt">
			<label class="inquiry-form__label">
				<input type="hidden" name="gdpr_accept" value="false" class="inquiry-form__input-check">
				<input type="checkbox" name="gdpr_accept" value="true" class="inquiry-form__input-check">
				<span style="margin-left:5px;" v-html="msg.form_gdpr+(required_fields.gdpr_accept?' *':'')"></span>
			</label>
			<label class="inquiry-form__label">
				<input type="hidden" name="newsletter_accept" value="false" class="inquiry-form__input-check">
				<input type="checkbox" name="newsletter_accept" value="true" class="inquiry-form__input-check">
				<span style="margin-left:5px;" v-html="msg.form_newsletter+(required_fields.newsletter_accept?' *':'')"></span>
			</label>

		</div>

	</div>
</div>

</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapState } from "vuex";

	export default {
		props: {
			msg: Object,
			required_fields: Object
		},
		components: {
			Multiselect
		},
		data() {
			return {
				mediaData: [],
				selectedMediaType: "",
				coverageType: [],
				selectedCoverageType: ""
			}
		},
		created(){
			this.mediaData = [this.msg.newspaper,this.msg.magazine,this.msg.online_np_mg,this.msg.blog,this.msg.broadcast,this.msg.radio,this.msg.smedia_only]
			this.coverageType = [this.msg.review,this.msg.photo,this.msg.mention,this.msg.fact_box,this.msg.sm_posts,this.msg.concierge_other]
		},
		computed: {
			...mapState({
				msg: state => state.msg,
			})
		}
	}
</script>

<style>

</style>
